import { Contact }              from '../types';
import env                      from '../env';
import { createCacheableFetch } from '@statflo/fetch';

const cachedFetch = createCacheableFetch<Contact>();

export default async function contactService(banId: string, contactId: number, token: string): Promise<Contact> {
    const endPoint = `${env.WEBAPP_HOST}v2/api/accounts/${banId}/contact/${contactId}?metadata[]=opportunity&metadata[]=subscription`;
    const requestInit: RequestInit = {
        method: 'GET',
        headers: new Headers({
            authorization: `Bearer ${token}`
        }),
        mode: 'cors',
    };

    const contact = await cachedFetch(endPoint, requestInit);
    return contact;
}



// WEBPACK FOOTER //
// ./src/services/ContactService.ts